import React, { useEffect, useRef, useState } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.bubble.css';
import 'quill/dist/quill.snow.css';
import PropTypes from 'prop-types';

export default function Editor({
  text,
  withEditor,
  className,
  onChange,
  idContent,
}) {
  const editorContainerRef = useRef(false);
  const [loaded, setLoaded] = useState(false);
  const [content, setContent] = useState(false);
  const toolbarOptions = [
    [{ font: [] }],
    [{ size: ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline', 'strike'],

    [{ color: [] }, { background: [] }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ header: 1 }, { header: 2 }],
    ['blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }],

    [{ indent: '-1' }, { indent: '+1' }],
    [{ direction: 'rtl' }],

    [{ align: [] }],
    ['link', 'image'],
    ['clean'],
  ];

  useEffect(() => {
    if (!loaded) {
      const quillFunc = new Quill(editorContainerRef.current, {
        modules: {
          toolbar: withEditor && toolbarOptions,
        },
        placeholder: 'Entre com seu texto...',
        theme: withEditor ? 'snow' : 'bubble', // Specify theme in configuration
      });
      quillFunc.root.style.maxHeight = '1000px';
      quillFunc.root.style.minHeight = '300px';
      quillFunc.on('text-change', () => {
        setContent(quillFunc.root.innerHTML);
        onChange(quillFunc.root.innerHTML);
      });
      setLoaded(true);
    }
    setContent(text);
  }, [withEditor]);

  return (
    <div>
      <div
        className={`bg-white ${className || ''}`}
        ref={editorContainerRef}
        dangerouslySetInnerHTML={{ __html: text }}
      />
      <div className="visually-hidden" id={idContent}>
        {content}
      </div>
    </div>
  );
}

Editor.defaultProps = {
  className: '',
  text: '',
  withEditor: true,
  idContent: `editor_content_${Date.now().toString(36)}`,
  onChange: () => {},
};

Editor.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  withEditor: PropTypes.bool,
  onChange: PropTypes.func,
  idContent: PropTypes.string,
};
